<script setup lang="ts">
import { onMounted } from "vue";
import OrderList from "./OrderList.vue";

defineOptions({ name: "Order" });

const { t } = useI18n();
const { set: setTitle } = usePageTitle();

onMounted(() => {
  setTitle(t("order.title"));
});
</script>

<template>
  <OrderList />
</template>
